<template>
<div class="order-summary relative">
  <div v-if="previewIsLoading" class="cart-preview-preloader absolute">
    <i class="fad fa-spinner-third fa-spin text-3xl"></i>
  </div>
  <table :class="{'cart-preview-content-loading opacity-30': previewIsLoading}">
    <tr v-if="minOrderPrice && minOrderPrice.value > orderTotalPrice.value" class="text-danger">
      <td>Минимальная сумма</td>
      <td>{{ priceToText(minOrderPrice) }}</td>
    </tr>
    <tr v-if="orderDiscountDifference">
      <td>Скидка</td>
      <td>-{{ priceToText(orderDiscountDifference) }}</td>
    </tr>
    <tr v-if="bonuses" class="order-summary__bonuses">
      <td>Оплата бонусами</td>
      <td>- {{ priceToText(bonuses) }}</td>
    </tr>
    <tr v-if="hasServiceFee" class="order-summary__cashback-preview">
      <td>Сервисный сбор</td>
      <td>{{ priceToText(paymentsPreview.service_fee) }}</td>
    </tr>
    <tr class="order-summary__to-pay">
      <td>Итого к оплате</td>
      <td>{{ priceToText(toPay) }}</td>
    </tr>
    <tr v-if="loyaltyEnabled && paymentsPreview" class="order-summary__cashback-preview">
      <td>Будет начислено бонусов</td>
      <td>{{ priceToText(paymentsPreview.cashback) }}</td>
    </tr>
    <tr v-if="loyaltyEnabled && hasBonusesReward" class="order-summary__cashback-preview">
      <td>
        Подарочные бонусы за акции
      </td>
      <td>
        {{ priceToText(bonusesReward.total_amount) }}
      </td>
    </tr>
  </table>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import priceToText from '@/helpers/priceToText'
import getBonusesPaymentAmount from '@/helpers/getBonusesPaymentAmount'

function isPriceOrNull(v){
  return v === null || v.currency !== undefined;
}

export default {
  props: {
    paymentsPreview: {
      required: true,
      validator(v) {
        return v === null || v.unpaid instanceof Object;
      },
    },

    orderTotalPrice: {
      required: true,
      validator(v) {
        return v === null || v.currency instanceof Object;
      },
    },

    orderOriginalTotalPrice: {
      required: false,
      default: null,
    },

    orderDiscountDifference: {
      required: false,
      default: null,
    },
  },

  computed: {
    ...mapGetters({
      loyaltyEnabled: 'store/loyaltyEnabled',
      minOrderPrice: 'store/minOrderPrice',
      promotionRewards: 'order/rewards',
      paymentsPreviewIsLoading: 'order/paymentsPreviewIsLoading',
      promotionsAreChecking: 'order/promotionsAreChecking',
    }),

    previewIsLoading() {
      return this.paymentsPreviewIsLoading || this.promotionsAreChecking
    },

    bonuses() {
      return this.paymentsPreview && getBonusesPaymentAmount(this.paymentsPreview.payments) || null;
    },

    toPay() {
      return this.paymentsPreview
        ? this.paymentsPreview.unpaid // Assuming that we only sent the bonuses payment draft.
        : this.orderTotalPrice;
    },

    hasCashback() {
      if (!this.paymentsPreview) {
        return false
      } else if (!this.paymentsPreview.cashback) {
        return false
      }

      return !!this.paymentsPreview.cashback.total
    },

    hasServiceFee() {
      if (!this.paymentsPreview) {
        return false;
      } else if (typeof this.paymentsPreview.service_fee === 'undefined') {
        return false;
      } else if (this.paymentsPreview.service_fee === null || typeof this.paymentsPreview.service_fee !== 'object') {
        return false;
      }

      return this.paymentsPreview.service_fee.value > 0;
    },

    hasBonusesReward() {
      if (!this.promotionRewards || !this.promotionRewards.length) {
        return false
      }

      return this.promotionRewards.findIndex(reward => reward.type.id === 'bonuses' && reward.total_amount !== null) !== -1
    },

    bonusesReward() {
      return this.promotionRewards.find(reward => reward.type.id === 'bonuses' && reward.total_amount !== null)
    },
  },

  methods: {
    priceToText,
  },
}
</script>
